import { CSSProperties } from 'react';
import { IntlMessageId } from 'locale';
import { PermissionAction, PermissionName } from '@utmost.co/enterprise-models';
import { LaunchDarklyFeatureFlagKeys } from 'integrations/launchDarkly/legacy/LaunchDarklyFeatureFlags.types';
import { FeaturesNames } from 'src/definitions/custom-models';

export enum MenuItem {
  myUtmost = 'myutmost',
  dashboards = 'dashboards',
  reports = 'reports',
  analyticsDashboards = 'analytics-dashboards',
  workRequests = 'work-requests',
  jobPostings = 'job-postings',
  jobApplications = 'job-applications',
  invoicing = 'invoices',
  myAccount = 'my-account',
  allTasks = 'all-tasks',
  tasks = 'tasks',
  orgNavigator = 'chart',
  workers = 'workers',
  programAlerts = 'program-alerts',
  engagements = 'engagements',
  suppliers = 'suppliers',
  projects = 'projects',
  contracts = 'contracts',
  timeAndExpenses = 'time-and-expenses',
  workflows = 'workflows',
  settings = 'settings',
  configuration = 'configs',
  processes = 'processes',
  dataExtracts = 'data-extracts'
}

export type MenuPermission = {
  name: PermissionName;
  action: PermissionAction;
};

export interface MenuNode {
  icon: JSX.Element;
  messageId: IntlMessageId;
  // use messageId translation instead of featureId label
  useMessageIdFirst?: boolean;
  id: MenuItem;
  featureId?: FeaturesNames;
  subFeatureId?: 'work-request' | 'job-posting' | 'job-application' | 'contract';
  darklyFlagKey?: LaunchDarklyFeatureFlagKeys;
  permission?: MenuPermission;
  subPermission?: MenuPermission;
  style?: CSSProperties;
  show?: boolean;
  text: string;
  group: 'utmost' | 'hub' | 'sourcing' | 'settings' | 'finance';
  isLastFromGroup: boolean;
}
